import React, { useState } from "react";

const Setting = () => {
  const [ischeckedtheme] = useState(localStorage.getItem("eoffice-theme"));
  const [themeChange, setThemeChange] = useState(
    localStorage.getItem("eoffice-theme") === "" ||
      localStorage.getItem("eoffice-theme") === null
      ? "2"
      : "1"
  );
  const [header] = useState(localStorage.getItem("eoffice-header"));
  // const [leftmenu, setLeftmenu] = useState(
  //   localStorage.getItem("eoffice-left-menu") === "" ||
  //     localStorage.getItem("eoffice-left-menu") === null
  //     ? "leftMenuWhite"
  //     : "leftMenuDark"
  // );

  return (
    <>
      <div className="menu-header-content bg-primary-gradient text-left d-flex">
        <div>
          <h5 className="menu-header-title text-white mb-0">Тохиргоо</h5>
        </div>
      </div>
      <div className="main-message-list chat-scroll">
        <div className="p-3">
          <h3 className="notification-label">Үндсэн өнгө</h3>
          <label className="customradiocontainer">
            <span>Цагаан</span>
            <input
              type="radio"
              name="theme"
              id="changetheme"
              value="2"
              defaultChecked={
                ischeckedtheme === "" || ischeckedtheme === null
                  ? "checked"
                  : ""
              }
              onChange={(e) => setThemeChange(e.target.value)}
            />
            <span className="checkmark" />
          </label>
          <label className="customradiocontainer">
            Хар
            <input
              type="radio"
              name="theme"
              id="changetheme"
              value="1"
              defaultChecked={ischeckedtheme === "dark-theme" ? "checked" : ""}
              onChange={(e) => setThemeChange(e.target.value)}
            />
            <span className="checkmark" />
          </label>
        </div>
        {themeChange === "2" ? (
          <div className="p-3">
            <h5 className="notification-label">Толгой хэсгийн өнгө</h5>

            <>
              <label className="customradiocontainer">
                Градиент
                <input
                  type="radio"
                  name="changeheader"
                  id="changeheader"
                  value="1"
                  defaultChecked={
                    header === "" || header === null ? "checked" : ""
                  }
                />
                <span className="checkmark" />
              </label>
              <label className="customradiocontainer">
                Хар
                <input
                  type="radio"
                  name="changeheader"
                  id="changeheader"
                  value="2"
                  defaultChecked={header === "header-dark3" ? "checked" : ""}
                />
                <span className="checkmark" />
              </label>
            </>
          </div>
        ) : (
          ""
        )}

        {/* {themeChange === "2" ? (
          <div className="p-3">
            <h5 className="notification-label">Цэсний өнгө</h5>
            <label className="customradiocontainer">
              Цагаан
              <input
                type="radio"
                name="leftmenu"
                id="leftmenu"
                value="leftMenuWhite"
                defaultChecked={leftmenu === "leftMenuWhite" ? "checked" : ""}
                onChange={(e) => setLeftmenu(e.target.value)}
              />
              <span className="checkmark" />
            </label>
            <label className="customradiocontainer">
              Хар
              <input
                type="radio"
                name="leftmenu"
                id="leftmenu"
                value="leftMenuDark"
                defaultChecked={leftmenu === "leftMenuDark" ? "checked" : ""}
                onChange={(e) => setLeftmenu(e.target.value)}
              />
              <span className="checkmark" />
            </label>
          </div>
        ) : (
          ""
        )} */}
      </div>
    </>
  );
};

export default React.memo(Setting);
